import { graphql } from '../../../gql';

export const REPUBLISH_POST_MUTATION = graphql(`
  mutation republishPost($postId: ID!) {
    republishPost(postId: $postId) {
      id
      status
      savedSinceModeration
      analyzedSinceLastSave
      updatedAt
    }
  }
`);
